import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BillingGeneratorService } from '../../../services/billing-generator.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import {
  ColDef, GridApi, GridReadyEvent, RowClassParams, RowStyle,
  ClientSideRowModelModule, RowGroupingModule, ModuleRegistry, RowGroupingDisplayType, UseGroupTotalRow
} from 'ag-grid-enterprise';
import * as dayjs from 'dayjs';
import * as tz from 'dayjs/plugin/timezone';
import * as utc from 'dayjs/plugin/utc';
import * as duration from 'dayjs/plugin/duration';

dayjs.extend(utc);
dayjs.extend(tz);
dayjs.extend(duration);

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.css']
})

export class BillingComponent implements OnInit {
  @ViewChild('dt_from') dt_from!: ElementRef<HTMLInputElement>;
  @ViewChild('dt_thru') dt_thru!: ElementRef<HTMLInputElement>;
  columnDefs: ColDef[] = [];
  columnDefsList: ColDef[] = [];
  dtFrom = "2025-12-01";
  dtThru = "2025-12-31";
  clientList: any[] = [];
  errorMsg = "";
  gridApi!: GridApi<any>;
  listInvoices: any[] = [];
  rowData: any[] = [];
  rowSelection: any = "single";
  selectedClients: any[] = [];
  filterClients: any[] = [];
  filterPeriods: any[] = [];
  token = "";
  isContentLoaded = false;
  showModal = "none";
  showMinutesSaved = true;
  showMinutesEditor = true
  authUser = sessionStorage.getItem('wOSAuthUser');
  authAdmin = sessionStorage.getItem('wOSAdmin');
  userID = this.authUser;
  markdownContent = '';
  ddSettingsClients: IDropdownSettings = {};
  groupColumnDef: ColDef = { minWidth: 150, headerName: "Entry Date", cellRenderer: "agGroupCellRenderer" };
  groupDefaultExpanded = 0;
  groupTotalRow: "top" | "bottom" | UseGroupTotalRow = "bottom";
  suppressAggFuncInHeader = true;
  defaultColDef: ColDef = { flex: 1, minWidth: 100 };
  groupDisplayType: RowGroupingDisplayType = "groupRows";


  constructor(
    private billingService: BillingGeneratorService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    const user: any = sessionStorage.getItem('wOSUser');
    this.token = JSON.parse(user).stsTokenManager.accessToken;

    this.ddSettingsClients = {
      singleSelection: false,
      idField: 'id',
      textField: 'old_name',
      enableCheckAll: true,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
      unSelectAllText:"Deselect All"
    };
  }

  onGridReady(params: GridReadyEvent): void {
    this.gridApi = params.api;
    this.buildColumnSpec(this.listInvoices);
    this.gridApi.sizeColumnsToFit();
    this.loadUXData();
  }

  loadUXData(): void {
    this.billingService.loadUXData({},this.token)
      .then((data:any) => {
        this.rowData = data.bills;
        this.filterClients = data.clients;
        setTimeout(() => {
          this.gridApi.sizeColumnsToFit();
        })
      })
      .catch((err:any) => console.error('Error loading assets:', err));
  }

  onClientSelect(item: any) {
    console.log("onClientSelect", this.clientList)
    //this.entryForm.taskID = item.id;
    //this.getTaskAssignees();
  }

  showCalendar(ctl: string): void {
    console.log("showCalendar")
    switch (ctl) {
      case 'dt_from':
        this.dt_from.nativeElement.showPicker();
        break;
      default:
        this.dt_thru.nativeElement.showPicker();
        break;
    }
  }

  groupRowRendererParams = {
    suppressCount: false,
    innerRenderer: (params: any) => {
      const { value, node } = params;
      const aggData = node.aggData || {};
      const currencySum = aggData['Account Value'] || 0;
      return `<span>${value} (Total: $${currencySum.toLocaleString()})</span>`;
    },
  };


  generateBills(): void {
    if (this.clientList.length == 0) {
      alert("No clients selected.  Select at least one client to continue.");
      return;    
    }

    const delimitedString = this.clientList.map(item => item.id).join(",");
    
    this.gridApi.setGridOption('loading', true);
    this.billingService.generateBills(delimitedString, this.dtFrom, this.dtThru, this.token).then(r => {
      this.loadUXData();
      this.gridApi.setGridOption('loading', false);
    })
  }
  

  buildColumnSpec(table: any): any {
    const tbl = ['batch_id','invoice_number', 'file_url', 'billing_period', 'notes', 'terms','dt_created'];
    const labels: any[] = ['Batch','Invoice #', 'File Name', 'Period', 'Notes', 'Terms','Creation Date'];
    const alignments: any[] = ['center', 'center', 'left', 'center', 'left', 'center','center'];
    const widths: any[] = [100,125, 0, 120, 400, 125,200];
    const hides: any[] = ['billing_period','notes'];
    const expander = 'file_url';

    let i = 1;
    this.columnDefs = tbl.map((col) => {
      let returnedColDef = {};

      const baseColDef = {
        cellClass: (alignments[i - 1] !== 'left') ? ['text-' + alignments[i - 1]] : [],
        field: col,
        headerName: labels[i - 1],
        headerTooltip: labels[i - 1],
        headerClass: 'text-center',
        editable: false,
        sortable: true,
        filter: false,
        resizable: true,
        width: widths[i - 1],
        tooltipField: col,
        suppressHeaderMenuButton: true,
        suppressSizeToFit: (col == expander) ? false : true,
        cellRenderer: this.cellRenderer,
        cellDataType: (col == 'billable') ? 'boolean' : '',
        hide: (hides.includes(col.toLowerCase())) ? true : false
      };

      if (col === 'batch_id') {
        console.log("Batch ID Column")
        returnedColDef = {
          ...baseColDef,
          rowGroup: true,
          hide: true, // show the column
          cellRenderer: (params: any) => {
            // only show date for leaf rows, not group headers
            if (params.node.group) return '';
            return params.value;
          }
        };
      } else if (col === 'file_url') {
        returnedColDef = {
          ...baseColDef,
          cellRenderer: (params: any) => {
            const link = document.createElement('span');
            const field = params.data.file_url;
            const label = params.data.file_url.substring(params.data.file_url.lastIndexOf('/') + 1,params.data.file_url.length);
            link.className = 'pointer';
            link.innerHTML = `<a href="${field}" target="_blank">${label}</a>`;
            return link;
          },
          cellRendererParams: {},
          field: `id`,
          suppressHeaderMenuButton: true,
          suppressHeaderFilterButton: true,
          resizable: false
        };
      } else if (col === 'dt_created') {
        returnedColDef = {
          ...baseColDef,
          cellRenderer: (params: any) => {
            const label = dayjs(params.data.dt_created).format("DD MMM YYYY h:mA");
            return label;
          },
          cellRendererParams: {},
          field: `id`,
          suppressHeaderMenuButton: true,
          suppressHeaderFilterButton: true
        };
      } else {
        returnedColDef = baseColDef;
      }

      i++;
      return returnedColDef;
    });

    // Custom group row display for batch info
    this.groupRowRendererParams = {
      suppressCount: true,
      innerRenderer: (params: any) => {
        const { value, node } = params;

        console.log("groupRowRendererParams",node)
        const batchid = value; // add weekday name to group headers
        //const dtstamp = dayjs(value).format('DD MMM');

        const batch = this.rowData.find(batch => batch.batch_id == batchid);
        console.log("batch record", batch);


        let batchCount = 0;
        const dtfrom = dayjs(batch.dt_from).format('DD MMM YYYY');
        const dtthru = dayjs(batch.dt_thru).format('DD MMM YYYY');
        const clientLabel = batch.client_initials
        //let total = 0;

        // Walk the children and sum durations
        node.childrenAfterFilter?.forEach((child: any) => {
          console.log("children after",child)
          batchCount++
        });

        return `
        <span style="font-weight:normal !important">
          <strong class="me-3">Batch ${batchid}</strong> ${dtfrom} - ${dtthru}
          <span class="mx-4">${clientLabel}</span>
          <span class="mx-4"><span class="badge bg_bone c_greydk">${batchCount}</span></span>
        </span>
        `;
      }
    };
  }

  onSelectionChanged(event: any): void {
    //if (event.source != "apiSelectAll") { }
    console.log("Selection changed")
  }

  cellRenderer(params: any) {
    let template: any = '';
    switch (params.colDef.field) {
      default:
        template = params.getValue();
        break;
    }
    return template;
  }

  getRowStyle = (params: RowClassParams): RowStyle | undefined => {
    // Apply style to group rows
    if (params.node.group) {
      return {
        backgroundColor: 'var(--welarabonemd)',
        fontWeight: 'bold'
      };
    }

    return undefined;
  };

  toggleModal(mode: string): void {
    this.showModal = (mode === 'show') ? 'block' : 'none';
  }

  trackByFn(index: any, record: any) {
    return record.id
  }
}
